export const MAX_OUTPUT_FORM_NAME_LENGTH = 110